module.exports = __webpack_public_path__ + "img/9aac309d770afe84e7c0084166bc0191.3405ef5b.png";